(function(){
    'use strict';



    jcu_js_v1.fn.initMultilineTextResizing = function(){
        var allTexts = document.querySelectorAll('.jcu-v1__ct__hl-personnel__rel-study__link');

        allTexts.forEach(element => {
            
            var fontSize = window.getComputedStyle(element, null).getPropertyValue('font-size').replace('px','');
            var width = window.getComputedStyle(element.parentNode, null).getPropertyValue('width').replace('px','');

            var totallyMaths = Math.ceil(width/fontSize);
            var text = element.innerHTML.split(" ");
            
            var lengthCounter = 0;
            var nextText = [];

            text.forEach(textElement => {
                lengthCounter += textElement.length;
                if(lengthCounter > totallyMaths){                     
                    nextText.push("<br/>"); 
                    lengthCounter = 0;                  
                }
                nextText.push(textElement);
            });
            element.innerHTML = nextText.join(' ');
        });
    }



    
    
    jcu_js_v1.fn.initTemplateShare = function(){
        jcu_js_v1.vars.allShareButtons = document.querySelectorAll('.jcu-v1__ct__hl-personnel__share-link');

        if(jcu_js_v1.vars.allShareButtons.length > 0){
            for(var i = 0; i < jcu_js_v1.vars.allShareButtons.length; i++){
                var shareButton = jcu_js_v1.vars.allShareButtons[i];
                shareButton.addEventListener('click', jcu_js_v1.fn.templateShareClickHandler);
                // console.log(shareButton.parentNode);
            }
            
        }


        /*if(document.querySelector('.jcu-v1__ct__hl-personnel__share-link') !== null){
            jcu_js_v1.vars.templateShareButton = document.querySelector('.jcu-v1__ct__hl-personnel__share-link');
            jcu_js_v1.vars.templateActionsContainer = document.querySelector('.jcu-v1__ct__hl-personnel__share');
            jcu_js_v1.vars.templateShareButton.addEventListener('click', jcu_js_v1.fn.templateShareClickHandler);
        }*/
    }

    jcu_js_v1.fn.templateShareClickHandler = function(e) {
        e.preventDefault();
        //if another share is currently open close it
        if(typeof(jcu_js_v1.vars.templateShareCurrentShare ) !== "undefined"){
            if(jcu_js_v1.vars.templateShareCurrentShare !== null){
                jcu_js_v1.fn.templateCloseShareModal();            
            }
        }
        
        
        //set the current target so we can reference in other functions
        jcu_js_v1.vars.templateShareCurrentShare = e.currentTarget;
        jcu_js_v1.vars.templateShareCurrentShareParent = jcu_js_v1.vars.templateShareCurrentShare.parentNode;
        var title = document.querySelector('.jcu-v1__ct__hl-personnel__content-header').innerHTML;
        var url = window.location.href;

        // Web share API
        if (navigator.share) {
            navigator.share({
                title: title,
                url: url
            }).then(function() {
                // console.log('Thanks for sharing!');
            }).catch(console.error);
        }

        // Fallback
        else {
            jcu_js_v1.fn.templateToggleShareModal();
        }
    }
    

    jcu_js_v1.fn.templateToggleShareModal = function() {
        // console.log('toggle modal');

        //
        var modal = jcu_js_v1.vars.templateShareCurrentShareParent.querySelector('.jcu-v1__ct__hl-personnel__share-modal');

        // Close modal
        if (modal.classList.contains('open')) {
            jcu_js_v1.fn.templateCloseShareModal();
        }

        // Open modal
        else {
            jcu_js_v1.fn.templateOpenShareModal();
        }
    }

    jcu_js_v1.fn.templateHandleBackgroundClick = function(e) {
        var modal = document.querySelector('.jcu-v1__ct__hl-personnel__share-modal');
        var isClickInside = modal.contains(e.target);
        //var isClickBtn = jcu_js_v1.vars.templateShareButton.contains(e.target);
        var isClickBtn = jcu_js_v1.vars.templateShareCurrentShare.contains(e.target);

        if (!isClickInside && !isClickBtn) {
            // console.log('background clicked');
            jcu_js_v1.fn.templateCloseShareModal();
        }
    }

    jcu_js_v1.fn.templateCloseShareModal = function() {
        
        // Add expanded attr
       // jcu_js_v1.vars.templateShareButton.setAttribute('aria-expanded', 'false');
       jcu_js_v1.vars.templateShareCurrentShare.setAttribute('aria-expanded', 'false');
        
        // Hide modal
        var modal = jcu_js_v1.vars.templateShareCurrentShareParent.querySelector('.jcu-v1__ct__hl-personnel__share-modal');
        modal.classList.remove('open');

        // Remove event listeners
        jcu_js_v1.vars.templateShareCurrentShareParent.removeEventListener('keydown', jcu_js_v1.fn.templateShareTrapTabKey);

        document.body.removeEventListener('click', jcu_js_v1.fn.templateHandleBackgroundClick);

        // Focus on share button
        jcu_js_v1.vars.templateShareCurrentShare.focus();
        jcu_js_v1.vars.templateShareCurrentShare = null;
            jcu_js_v1.vars.templateShareCurrentShareParent = null;
    }

    jcu_js_v1.fn.templateOpenShareModal = function() {
        
        // Add expanded attr
        //jcu_js_v1.vars.templateShareButton.setAttribute('aria-expanded', 'true');
        jcu_js_v1.vars.templateShareCurrentShare.setAttribute('aria-expanded', 'true');

        // Open modal
        var modal = jcu_js_v1.vars.templateShareCurrentShareParent.querySelector('.jcu-v1__ct__hl-personnel__share-modal');
        modal.classList.add('open');
        
        // Handle background click
        document.body.addEventListener('click', jcu_js_v1.fn.templateHandleBackgroundClick);

        // Listen for and trap the keyboard
        jcu_js_v1.vars.templateShareCurrentShareParent.addEventListener('keydown', jcu_js_v1.fn.templateShareTrapTabKey);

        // Focus first child
        var facebookLink = document.getElementById('course-share-facebook');
		//facebookLink.focus();

    }

    jcu_js_v1.fn.templateShareTrapTabKey = function(e) {
        //var firstTabStop = jcu_js_v1.vars.templateShareButton;
        var firstTabStop = jcu_js_v1.vars.templateShareCurrentShare;
        var lastTabStop = jcu_js_v1.vars.templateShareCurrentShareParent.querySelector('#course-share-email');

        // Check for TAB key press
        if (e.keyCode === 9) {

            // SHIFT + TAB
            if (e.shiftKey) {
                if (document.activeElement === firstTabStop) {
                    e.preventDefault();
                    lastTabStop.focus();
                }

                // TAB
            } else {
                if (document.activeElement === lastTabStop) {
                    e.preventDefault();
                    firstTabStop.focus();
                }
            }
        }

        // ESCAPE
        if (e.keyCode === 27) {
            jcu_js_v1.fn.templateCloseShareModal();
        }
    }

    jcu_js_v1.fn.initTemplateShare();
    jcu_js_v1.fn.initMultilineTextResizing();
    
}());
